export const AUDIT_PERMISSION_CODES = {
    WEB_AUDIT_LIST: 'WEB_AUDIT_LIST',
    WEB_AUDIT_DETAIL: 'WEB_AUDIT_DETAIL',
    WEB_AUDIT_ADD: 'WEB_AUDIT_ADD',
    WEB_AUDIT_EDIT: 'WEB_AUDIT_EDIT',
    WEB_AUDIT_DELETE: 'WEB_AUDIT_DELETE',
    WEB_AUDIT_IMPORT: 'WEB_AUDIT_IMPORT',
    WEB_AUDIT_EXPORT: 'WEB_AUDIT_EXPORT',
} as const;

